import { useEffect } from "react";

const CLOSE_AFTER_PX = 120;

/** Bottom-sheet gesture: when the sheet is scrolled to the top, dragging down follows the finger and closes past the threshold. */
export function useSwipeToClose(ref, onClose, key) {
  useEffect(() => {
    const el = ref.current;
    if (!el || !window.matchMedia("(max-width: 767px)").matches) return;
    let startY = 0;
    let dragging = false;

    const onStart = (e) => {
      dragging = el.scrollTop <= 0;
      startY = e.touches[0].clientY;
      el.style.transition = "";
    };
    const onMove = (e) => {
      if (!dragging) return;
      const dy = e.touches[0].clientY - startY;
      if (dy <= 0) { el.style.transform = ""; return; }
      el.style.transform = `translateY(${dy}px)`;
    };
    const onEnd = (e) => {
      if (!dragging) return;
      dragging = false;
      const dy = e.changedTouches[0].clientY - startY;
      el.style.transition = "transform 200ms ease-out";
      if (dy > CLOSE_AFTER_PX) {
        el.style.transform = "translateY(100%)";
        setTimeout(onClose, 180);
      } else {
        el.style.transform = "";
      }
    };

    el.addEventListener("touchstart", onStart, { passive: true });
    el.addEventListener("touchmove", onMove, { passive: true });
    el.addEventListener("touchend", onEnd, { passive: true });
    return () => {
      el.removeEventListener("touchstart", onStart);
      el.removeEventListener("touchmove", onMove);
      el.removeEventListener("touchend", onEnd);
    };
  }, [ref, onClose, key]);
}
